import React from 'react';
import Registration from './partials/registration';
import Roster from './partials/roster';
import Coaches from './partials/coaches';
import Uniforms from './partials/uniforms';
import Fields from './partials/fields';
import Goals from './partials/goals';
import Duration from './partials/duration';
import Standings from './partials/standings';
import Poo from './partials/poo';
import Extra from './partials/extra';
import { Animated } from 'react-animated-css';

// August 7th: refactored for responsiveness
class Rules extends React.Component {
    state = { tab: 1 }
    onTab = tab => this.setState({ tab });
    render() {
        const { tab } = this.state, { hideTitle = false } = this.props;
        return (<div style={{ zIndex: 1, }} className="d-flex flex-row w3-container w3-content no-padding">
            <div className="w-75" style={{ zIndex: 1 }}>
                {!hideTitle && <Animated animationIn="fadeInLeft" animateOnce={true}><h1 className="hero-text anton white text-left">RULES</h1></Animated>}
                <Animated animationIn="slideInLeft" animationInDelay={100} animateOnce={true}
                    className="margin-bottom">
                    <div onClick={() => this.onTab(1)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 1 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Player Registration</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 1 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={200} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(2)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 2 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Roster</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 2 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={300} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(3)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 3 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Coaches</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 3 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={400} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(4)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 4 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Team Uniforms & Equipments</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 4 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={500} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(5)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 5 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Field Dimensions</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 5 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={600} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(6)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 6 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Goals & Goal Box</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 6 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={700} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(7)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 7 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Game Duration</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 7 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={900} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(8)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 8 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Standings</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 8 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={1100} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(9)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 9 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Playoff Overtime</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 9 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
                <Animated animationIn="slideInLeft" animationInDelay={1300} animateOnce={true} className="margin-bottom">
                    <div onClick={() => this.onTab(10)} className="pointer hoverable">
                        <h1 className={`white hind font-${tab === 10 ? '22' : '20'} toBold  no-margin no-padding toUpper`} style={{ lineHeight: 1 }}>Additional Rules</h1>
                        <section style={{ width: 61, borderBottom: `4px solid ${tab === 10 ? '#f44336' : 'transparent'}`, margin: 0, padding: 0 }} />
                    </div>
                </Animated>
            </div>
            <div style={{ width: 30 }} />
            <div className="w-100 white pb-4">
                {tab === 1 && <Animated animationIn="fadeInUp">
                    <Registration />
                </Animated>}

                {tab === 2 && <Animated animationIn="fadeInUp">
                    <Roster />
                </Animated>}

                {tab === 3 && <Animated animationIn="fadeInUp">
                    <Coaches />
                </Animated>}

                {tab === 4 && <Animated animationIn="fadeInUp">
                    <Uniforms />
                </Animated>}

                {tab === 5 && <Animated animationIn="fadeInUp">
                    <Fields />
                </Animated>}

                {tab === 6 && <Animated animationIn="fadeInUp">
                    <Goals />
                </Animated>}

                {tab === 7 && <Animated animationIn="fadeInUp">
                    <Duration />
                </Animated>}

                {tab === 8 && <Animated animationIn="fadeInUp">
                    <Standings />
                </Animated>}

                {tab === 9 && <Animated animationIn="fadeInUp">
                    <Poo />
                </Animated>}

                {tab === 10 && <Animated animationIn="fadeInUp">
                    <Extra />
                </Animated>}
            </div>
        </div>)
    }
}

export default Rules;



// WEBPACK FOOTER //
// ./src/components/rules/index.js